/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCall201Response
 */
export interface CreateCall201Response {
    /**
     * 
     * @type {number}
     * @memberof CreateCall201Response
     */
    id?: number;
}

/**
 * Check if a given object implements the CreateCall201Response interface.
 */
export function instanceOfCreateCall201Response(value: object): value is CreateCall201Response {
    return true;
}

export function CreateCall201ResponseFromJSON(json: any): CreateCall201Response {
    return CreateCall201ResponseFromJSONTyped(json, false);
}

export function CreateCall201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCall201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function CreateCall201ResponseToJSON(json: any): CreateCall201Response {
    return CreateCall201ResponseToJSONTyped(json, false);
}

export function CreateCall201ResponseToJSONTyped(value?: CreateCall201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

